import { Api } from "../../../api/api";

import { getBinanceChartList } from "./binanceList";
import { getCollectionChartList } from "./collectionList";

const getTrainingChartList = async () => {
  const { charts } = await Api.getCharts();
  return charts;
};

export const chartListRequests = {
  training: getTrainingChartList,
  binance: getBinanceChartList,
  collection: getCollectionChartList,
};
